import { LogoAzureColored } from "components/icons/generated";
import IconEmphasized from "ds/components/IconEmphasized";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AzureIntegrationView } from "../../../useSearchCloudIntegrations/gql";
import styles from "./styles.module.css";

const IntegrationsAzureTableTypeCell = ({
  ...cellProps
}: TableSimpleCellProps<AzureIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <IconEmphasized className={styles.typeIcon} icon={LogoAzureColored} />
    </TableSimpleCell>
  );
};

export default IntegrationsAzureTableTypeCell;
